import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import { SearchResult } from '@/models/Repository'

const state = {
  searchResult: new SearchResult({ count: 0, items: [] }),
  page: {
    pageNo: 1,
    pageSize: 100,
  },
  loading: false,
  sortOptions: {
    sortBy: 'remainingDays',
    descending: false,
  },
  filter: {
    serveStatus: 'all',
    keyword: '',
  },
}

const IODashboard = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default IODashboard
